import { useNavigate } from "react-router-dom";
import { useGetUserDepartmentsQuery } from "../../../../service/department-service";
import { ApplicationRoutes } from "../../../../routes";
import { UserDepartment } from "../../../../model/workflows/user-department";
import styles from "./steps.module.scss";

const getAvatarColor = (name: string) => {
	const colors = ["#EF4444", "#EC4899", "#10B981", "#6B7280", "#3B82F6", "#F59E0B", "#8B5CF6", "#14B8A6"];
	const index = name.charCodeAt(0) % colors.length;
	return colors[index];
};

export const DepartmentSelectionPage = () => {
	const navigate = useNavigate();
	const { data, isLoading, error } = useGetUserDepartmentsQuery();

	const handleDepartmentClick = (department: UserDepartment) => {
		navigate(`/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.STEPS}/${department.id}`);
	};

	if (isLoading) {
		return (
			<div className={styles.departmentSelectionContainer}>
				<div className={styles.departmentSelectionHeader}>
					<h2 className={styles.departmentSelectionTitle}>Select Department</h2>
				</div>
				<div className={styles.loadingState}>Loading departments...</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className={styles.departmentSelectionContainer}>
				<div className={styles.departmentSelectionHeader}>
					<h2 className={styles.departmentSelectionTitle}>Select Department</h2>
				</div>
				<div className={styles.errorState}>
					Error loading departments. Please try again.
				</div>
			</div>
		);
	}

	const departments = data?.departments ?? [];

	if (departments.length === 0) {
		return (
			<div className={styles.departmentSelectionContainer}>
				<div className={styles.departmentSelectionHeader}>
					<h2 className={styles.departmentSelectionTitle}>Select Department</h2>
				</div>
				<div className={styles.emptyState}>
					You are not a member of any department.
				</div>
			</div>
		);
	}

	return (
		<div className={styles.departmentSelectionContainer}>
			<div className={styles.departmentSelectionHeader}>
				<h2 className={styles.departmentSelectionTitle}>Select Department</h2>
				<p className={styles.departmentSelectionSubtitle}>
					Choose a department to view and manage steps
				</p>
			</div>

			<div className={styles.departmentGrid}>
				{departments.map(dept => (
					<div
						key={dept.id}
						className={styles.departmentCard}
						onClick={() => handleDepartmentClick(dept)}
					>
						<div className={styles.cardHeader}>
							<div className={styles.departmentInfo}>
								<div
									className={styles.avatar}
									style={{ backgroundColor: getAvatarColor(dept.name) }}
								>
									{dept.name.charAt(0).toUpperCase()}
								</div>
								<h3 className={styles.departmentName}>{dept.name}</h3>
							</div>
							<span
								className={`${styles.roleBadge} ${
									dept.role === "Supervisor" ? styles.supervisorBadge : styles.staffBadge
								}`}
							>
								{dept.role}
							</span>
						</div>
						<div className={styles.peopleCount}>
							{dept.peopleCount} {dept.peopleCount === 1 ? "Person" : "People"}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
